// ANGULAR DEPENDENCY
import { Injectable } from '@angular/core';

// NGRX AND RXJS
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

// GLOBAL ACTIONS, SELECTORS AND STATES
import { State } from '../root-state';
import * as actions from './store/actions';
import * as selectors from './store/selectors';

// COMMON INTERFACES
import { PopupNotification } from '../../models/global/popup/popup-notification.interface';

/**
 * These selectors are used for select data from global reducer
 * For global api call and store in global reducer purpose.
 *
 * @author Pratik Shihora <pratik@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 16/03/2020 (Pratik Shihora <pratik@saeculumsolutions.com>) initially created POPUP_NOTIFICATION, FAILURE, EMPTY Actions
 */
@Injectable()
export class GlobalStoreService {

  constructor(
    protected store: Store<State>,
  ) {
  }

  /************** Selectors ************** */

  // -------------------------------
  //  Select Popup Notification
  // -------------------------------
  selectPopupNotification(): Observable<PopupNotification> {
    return this.store.select(selectors.selectPopupNotification);
  }

  // -------------------------------
  //  Select Global Error
  // -------------------------------
  selectGlobalError(): Observable<any> {
    return this.store.select(selectors.selectGlobalError);
  }

  /************** Dispatchers ************** */

  // -------------------------------
  //  Dispatch Popup Notification
  // -------------------------------
  dispatchPopupNotification(payload: PopupNotification) {
    this.store.dispatch(new actions.PopupNotificationAction(payload));
  }

  // -------------------------------
  //  Dispatch Popup Notification Callback
  // -------------------------------
  dispatchPopupNotificationCallback(popupNotification: PopupNotification) {
    this.store.dispatch(new actions.PopupNotificationCallbackAction(popupNotification));
  }

  /************** Direct Api Call ************** */


}
